import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import searchIcon from "../../../../Assets/icons/searchicon.svg";
import viewDetailsIcon from "../../../../Assets/icons/viewDetails.svg";
import revenueIcon from "../../../../Assets/images/DashboardRevenue.png";
import arrowUpIcon from "../../../../Assets/icons/arrow-up 1.svg";
import axiosInstance from "../../../services/api/API";
import CanvasJSReact from "@canvasjs/react-charts";
import "./SalesDashboard.scss";
// import { format } from 'date-fns';
import { Form } from "react-bootstrap";
import Select from "react-select";
import { format, subDays, subWeeks, subMonths, subYears, set } from "date-fns";
import { useNavigate } from "react-router-dom";
import { MdAccessTime } from "react-icons/md";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const SalesDashboard = ({ card_id }) => {
  const token = localStorage.getItem("authToken");

  const dealer_id = localStorage.getItem("dealerId");
  const userType = localStorage.getItem("UserType");
  console.log(userType, "userType");

  const navigate = useNavigate();
  const navigateToManageOrder = () => {
    navigate("/manage-sales/manage-order");
  };

  const navigateToRiderSales = () => {
    navigate("/sales/manage-customer-purchase-order/purchase-order");
  };

  const [syncId, setSyncId] = useState("syncChart");
  const [revenueAmt, setRevenueAmt] = useState();
  const [riderAmt, setRiderAmt] = useState();
  const [poAmt, setPoAmt] = useState();
  const [customerSaleAmt, setCustomerSaleAmt] = useState();
  const [secondRowDataVehicleVal, setSecondRowDataVehicleVal] = useState({});
  const [secondRowDataItemVal, setSecondRowDataItemVal] = useState({});

  const [filterType, setFilterType] = useState("all");
  const [selectedDealerId, setSelectedDealerId] = useState(null);

  const [firstRowData, setFirstRowData] = useState({});
  // const [secondRowData, setSecondRowData] = useState({});
  const [dealerDd, setDealerdd] = useState([]);

  const [secondRowSecondSection, setSecondRowSecondSection] = useState({});

  const [secondRowThirdSection, setSecondRowThirdSection] = useState({});

  const [graphDataVal, setGraphDataVAl] = useState({});
  const [secGraphdataVal, setSecGraphDataVal] = useState({});
  const [filterYear, setFilterYear] = useState("all");
  const [variantOptions, setVariantOptions] = useState([]);
  const [filterVariant, setFilterVariant] = useState("all");

  const [activeFilter, setActiveFilter] = useState("24Hours");

    const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split("T")[0]; // 'YYYY-MM-DD'

  const formattedToday = currentDate.toISOString().split("T")[0];

  const yesterday = new Date(currentDate);
  yesterday.setDate(currentDate.getDate() - 1);
  const formattedYesterday = yesterday.toISOString().split("T")[0];

   const [fromDate, setFromDate] = useState(formattedYesterday);
    const [toDate, setToDate] = useState(formattedToday);

  useEffect(() => {
    Dealerdropdown();
  }, []);

  const getCurrentMonthDateRange = () => {
    const currentDate = new Date();
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
    );
    const lastDayOfMonth = new Date(currentDate);
    return {
      fromDate: firstDayOfMonth.toISOString().split("T")[0],
      toDate: lastDayOfMonth.toISOString().split("T")[0],
    };
  };

  const Dealerdropdown = async (id) => {
    try {
      const response = await axiosInstance.post(
        "/dealer/ddldealer",
        // { business_partner_id: 1 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = response.data.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.dealer_id,
        label: user.dealer_name,
      }));
      setDealerdd(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDateSelection = (period) => {
    let fromDate;
    const currentDate = new Date();

    switch (period) {
      case "24Hours":
        // fromDate = subDays(currentDate, 1); // Last 24 hours
        // break;
        fromDate = new Date(currentDate.getTime() - 24 * 60 * 60 * 1000); // Last 24 hours
        break;
      case "Week":
        fromDate = subWeeks(currentDate, 1); // Last week
        break;
      case "Month":
        fromDate = subMonths(currentDate, 1); // Last month
        break;
      case "Year":
        fromDate = subYears(currentDate, 1); // Last year
        break;
      default:
        fromDate = currentDate;
    }

    // Format dates as 'YYYY-MM-DD'
    const formattedFromDate = format(fromDate, "yyyy-MM-dd");
    const formattedToDate = format(currentDate, "yyyy-MM-dd");

    setActiveFilter(period);
    setFromDate(formattedFromDate); 
    setToDate(formattedToDate);
    // Call your function with the formatted dates
    // salesDashboardDetails(formattedFromDate, formattedToDate);
    fetchSalesSecondRowVal(formattedFromDate, formattedToDate);
    fetchSalesRevenue(formattedFromDate, formattedToDate);
    fetchSalesPoAmt(formattedFromDate, formattedToDate);
    fetchSalesCustomerTotal(formattedFromDate, formattedToDate);
    fetchSalesFirstGraph(formattedFromDate, formattedToDate);
    fetchSalesSecondGraph(formattedFromDate, formattedToDate);
  };



  useEffect(() => {
    fetchSalesSecondRowVal();
  }, []);

  const fetchSalesSecondRowVal = async (fromDate, toDate) => {
    try {
      //     const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;
      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-po-count",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data;
      setSecondRowDataVehicleVal(fetchedData?.vehicle);
      setSecondRowDataItemVal(fetchedData?.item);
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  useEffect(() => {
    fetchSalesRevenue();
  }, []);

  const fetchSalesRevenue = async (fromDate, toDate) => {
    try {
      // const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;

      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-revenue",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data;
      setRevenueAmt(fetchedData.totalRevenueAmount);
      setRiderAmt(fetchedData?.totalRiderAmount);
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  useEffect(() => {
    fetchSalesPoAmt();
  }, []);

  const fetchSalesPoAmt = async (fromDate, toDate) => {
    try {
      // const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;

      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-po-amt",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.totalPoAmount;
      setPoAmt(fetchedData);
      // setRiderAmt(fetchedData?.totalRiderAmount)
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };
  useEffect(() => {
    fetchSalesCustomerTotal();
  }, []);

  const fetchSalesCustomerTotal = async (fromDate, toDate) => {
    try {
      // const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;

      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-total-customer-sales",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.totalCustomerSales;
      setCustomerSaleAmt(fetchedData);
      // setRiderAmt(fetchedData?.totalRiderAmount)
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  // const salesDashboardDetails = useCallback(
  //   async (fromDate, toDate) => {
  //     try {
  //       let reqServiceOverviewType = "";
  //       let reqServiceValue = "";

  //       if (filterYear !== "all") {
  //         reqServiceOverviewType = "Y";
  //         reqServiceValue = filterYear;
  //       } else if (filterVariant !== "all") {
  //         reqServiceOverviewType = "V";
  //         reqServiceValue = filterVariant;
  //       }

  //       const currentDate = format(new Date(), "yyyy-MM-dd");

  //       const response = await axiosInstance.post(
  //         `sales/dashboard-list`,
  //         {
  //           reqServiceOverviewType: reqServiceOverviewType || "",
  //           reqServiceValue: reqServiceValue || "",
  //           toDate: currentDate || toDate,
  //           fromDate: fromDate || currentDate,
  //           dealer_id: dealer_id,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       const fetchedData = response?.data?.data;

  //       const firstRow = fetchedData?.firstRow;
  //       setFirstRowData(firstRow);

  //       const secondRow = fetchedData?.secondRow?.firstSection;
  //       console.log(secondRow, "secondRow");
  //       // setSecondRowData(secondRow);

  //       const secondRowSecondSectionVal = fetchedData?.secondRow?.secondSection;
  //       // setSecondRowSecondSection(secondRowSecondSectionVal);

  //       const thirdRowSecondSectionVal = fetchedData?.secondRow?.thirdSection;
  //       // setSecondRowThirdSection(thirdRowSecondSectionVal);

  //       const graphData = fetchedData?.graphList;
  //       console.log(graphData, "graphData");
  //       setGraphDataVAl(graphData);

  //       console.log(firstRow, "dashboardResponse");
  //     } catch (error) {
  //       console.log(error, "error");
  //     }
  //   },
  //   [filterYear, filterVariant, setGraphDataVAl]
  // );

  // useEffect(() => {
  //   salesDashboardDetails();
  // }, [filterYear, filterVariant, salesDashboardDetails]);

  useEffect(() => {
    getVariantDetails();
  }, []);

  const getVariantDetails = async () => {
    try {
      const response = await axiosInstance.post(`/variant/ddlvariant`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      setVariantOptions(response?.data?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSalesFirstGraph();
    // fetchSalesSecondGraph()
  }, []);

  useEffect(() => {
    fetchSalesSecondGraph();
  }, []);

  // Graph api call
  const fetchSalesFirstGraph = async (fromDate, toDate) => {
    try {
      // const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;
      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-list-overview",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.graphList;
      setGraphDataVAl(fetchedData);
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  const fetchSalesSecondGraph = async (fromDate, toDate) => {
    try {
      // const finalFromDate = fromDate || formattedDate;
      // const finalToDate = toDate || formattedDate;

      const finalFromDate = fromDate || formattedYesterday;
      const finalToDate = toDate || formattedToday;

      const response = await axiosInstance.post(
        "/sales/dashboard-sales-list-overview",
        {
          toDate: toDate || finalToDate,
          fromDate: fromDate || finalFromDate,
          dealerId: dealer_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const fetchedData = response.data?.data?.graphList;
      setSecGraphDataVal(fetchedData);
    } catch (error) {
      console.error("Error fetching service graph:", error);
    }
  };

  const currentYear = new Date().getFullYear();
  const lastFiveYears = Array.from(
    { length: 3 },
    (_, i) => currentYear - i,
  ).reverse(); // Creates an array from current year to the last 4 years

  // First Graph
  // Convert graphDataVal object to array of data points
  const dataPoints = useMemo(() => {
    return Object.entries(graphDataVal).map(([month, value]) => ({
      label: month,
      y: value,
    }));
  }, [graphDataVal]);
  const options = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    title: {
      text: "",
    },
    axisX: {
      title: "",
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 1,
      labelAngle: -45,
    },
    axisY: {
      title: "Unit", // Unit label
      titleFontSize: 18, // Reduced title font size
      labelFontSize: 15, // Reduced label font size
      includeZero: true,
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 50,
    },
    data: [
      {
        type: "column",
        dataPointWidth: 10,
        indexLabelFontColor: "#5A5757",
        indexLabelPlacement: "outside",
        dataPoints: dataPoints,
      },
    ],
  };

  // const options = {
  //   animationEnabled: true,
  //   exportEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "",
  //   },
  //   axisX: {
  //     title: "",
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   axisY: {
  //     title: "",
  //     includeZero: true,
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   data: [
  //     {
  //       type: "column",
  //       dataPointWidth: 10,
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints: dataPoints,
  //     },
  //   ],
  // };

  // Second Graph

  // const options = {
  //   animationEnabled: true,
  //   exportEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "",
  //   },
  //   axisX: {
  //     title: "",
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   axisY: {
  //     title: "",
  //     includeZero: true,
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //     interval: 1, // Force Y-axis labels to show only integers
  //   },
  //   data: [
  //     {
  //       type: "column",
  //       dataPointWidth: 10,
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints: dataPoints,
  //     },
  //   ],
  // };

  const dataPointsSec = useMemo(() => {
    return Object.entries(secGraphdataVal).map(([month, value]) => ({
      label: month,
      y: value,
    }));
  }, [secGraphdataVal]);

  // const optionsSec = {
  //   animationEnabled: true,
  //   exportEnabled: true,
  //   theme: "light2",
  //   title: {
  //     text: "",
  //   },
  //   axisX: {
  //     title: "",
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   axisY: {
  //     title: "",
  //     includeZero: true,
  //     labelFontColor: "#5A5757",
  //     gridThickness: 1,
  //     gridColor: "#E0E0E0",
  //   },
  //   data: [
  //     {
  //       type: "column",
  //       dataPointWidth: 10,
  //       indexLabelFontColor: "#5A5757",
  //       indexLabelPlacement: "outside",
  //       dataPoints: dataPointsSec,
  //     },
  //   ],
  // };

  const optionsSec = {
    animationEnabled: true,
    exportEnabled: true,
    theme: "light2",
    title: {
      text: "",
    },
    axisX: {
      title: "",
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 1,
      labelAngle: -65, // Optional
    },
    axisY: {
      title: "Unit",
      titleFontSize: 18, // Reduce Y-axis title font size
      labelFontSize: 15, // Reduce Y-axis label font size
      labelFontColor: "#5A5757",
      gridThickness: 1,
      gridColor: "#E0E0E0",
      interval: 50,
      includeZero: true,
    },
    data: [
      {
        type: "column",
        dataPointWidth: 10,
        indexLabelFontColor: "#5A5757",
        indexLabelPlacement: "outside",
        dataPoints: dataPointsSec,
      },
    ],
  };

  const navigateToCustomerPurchaseOrder = () => {
    navigate("/sales/manage-customer-purchase-order/purchase-order");
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #7BD755",
      boxShadow: "none",
      borderRadius: "20px",
      backgroundColor: "#fff",
      color: "#7BD755",
      width: "200px",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "green",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#7BD755",
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "4px",
    }),
    menuList: (provided) => ({
      ...provided,
      padding: 0,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#7BD755" : provided.backgroundColor,
      color: state.isFocused ? "#fff" : "#000",
    }),
  };

  const handleBusinessPartnerChange = (selectedOption) => {
    // const dealerId = selectedOption?.value || null;
    // setSelectedDealerId(dealerId);
    // fetch({
    //   fromDate: formattedDate,
    //   toDate: formattedDate,
    //   dealerId: dealerId,
    // });
  };

  return (
    <div className="sales-dashboard-main">
      <div className="filters-container">
        <div
          className="filtercontainer mt-3 mb-3"
          style={{
            display: "flex",
            flexDirection: "row",
            // paddingLeft: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
                paddingRight: "1rem",
              }}
            >
              {/* <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <span>Select Role</span>
                          <Form.Group controlId="formMonth" className="filter-dropdown">
                            <Select
                              isClearable
                              styles={customStyles}
                              options={dealerDd}
                              onChange={handleBusinessPartnerChange}
                              placeholder="Select Dealer"
                            />
                          </Form.Group>
                        </div> */}
              <div className="filter-buttons">
                <div
                  style={{
                    display: " flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "15px",
                    marginRight: "1.5rem",
                  }}
                >
                  <button
                    style={{ marginTop: "10px", borderRadius: "24px" }}
                    // className="submit-btn"
                    className={`filter-button ${
                      activeFilter === "24Hours" ? " active" : ""
                    }`}
                    onClick={() => handleDateSelection("24Hours")}
                  >
                    24 Hours
                  </button>
                  <button
                    style={{ marginTop: "10px", borderRadius: "24px" }}
                    // className="submit-btn"
                    className={`filter-button ${
                      activeFilter === "Week" ? " active" : ""
                    }`}
                    onClick={() => handleDateSelection("Week")}
                  >
                    Last Week
                  </button>
                  <button
                    style={{ marginTop: "10px", borderRadius: "24px" }}
                    // className="submit-btn"
                    className={`filter-button ${
                      activeFilter === "Month" ? " active" : ""
                    }`}
                    onClick={() => handleDateSelection("Month")}
                  >
                    Last Month
                  </button>
                  <button
                    style={{ marginTop: "10px", borderRadius: "24px" }}
                    // className="submit-btn"
                    className={`filter-button ${
                      activeFilter === "Year" ? " active" : ""
                    }`}
                    onClick={() => handleDateSelection("Year")}
                  >
                    Last Year
                  </button>
                  <span className="date-range-sales-dashboard">
                    <MdAccessTime className="icon" />
                    <span className="text">
                      {fromDate} <span className="separator">to</span> {toDate}
                    </span>
                  </span>
                </div>
              </div>
              <div>
                {/* <button
                  style={{ marginTop: "10px" }}
                  className="submit-btn-jhingat"
                  onClick={navigateToCustomerPurchaseOrder}
                >
                  Generate Sale Invoice
                </button> */}
                {userType !== "engineeruser" && (
                  <button
                    style={{ marginTop: "10px" }}
                    className="submit-btn-jhingat"
                    onClick={navigateToCustomerPurchaseOrder}
                  >
                    Generate Sale Invoice
                  </button>
                )}
              </div>
            </div>
            <div>
              <div style={{ display: "none" }} className="searchinput-wrapper">
                <input
                  type="text"
                  className="searchinput"
                  placeholder="Search Here"
                  value=""
                  onChange={() => {}}
                />
                <img
                  src={searchIcon}
                  alt="Search"
                  className="searchinput-icon"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mainCardsContainer mx-4">
        <div className="maintotalleadscontainer">
          <div className="maintotalsContainers">
            <div className="totalrevenuetitle">
              <div className="maintotalicons">
                <img src={revenueIcon} />
              </div>
              <div
                style={{ fontSize: "18px", fontWeight: "600" }}
                className="mt-2 card-heading-salesDashboard"
              >
                Total Revenue
              </div>
            </div>

            <span className="viewdetails">
              <img
                style={{ display: "none" }}
                className="viewimage"
                src={viewDetailsIcon}
              />
            </span>
          </div>
          <div className="AmountContaner mt-3">
            <h3 className="total"> {revenueAmt || "0"} </h3>
            <div>
              <div className="profitContainer">
                {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
              </div>
              {/* <p className="last24hrs">Last 24 Hours</p> */}
            </div>
          </div>
        </div>
        <div className="maintotalleadscontainer">
          <div className="maintotalsContainers">
            <div className="totalrevenuetitle">
              <div className="maintotalicons">
                <img src={revenueIcon} />
              </div>
              <div
                style={{ fontSize: "18px", fontWeight: "600" }}
                className="mt-2 card-heading-salesDashboard"
              >
                Total Purchase Order Amount
              </div>
            </div>

            <span className="viewdetails">
              <img
                onClick={navigateToManageOrder}
                className="viewimage"
                // src={viewDetailsIcon}
              />
            </span>
          </div>
          <div className="AmountContaner mt-3">
            <h3 className="total"> {poAmt || "0"} </h3>
            <div>
              <div className="profitContainer">
                {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
              </div>
              {/* <p className="last24hrs">Last 24 Hours</p> */}
            </div>
          </div>
        </div>
        <div className="maintotalleadscontainer">
          <div className="maintotalsContainers">
            <div className="totalrevenuetitle">
              <div className="maintotalicons">
                <img src={revenueIcon} />
              </div>
              <div
                style={{ fontSize: "18px", fontWeight: "600" }}
                className="mt-2 card-heading-salesDashboard"
              >
                Total Customer Sale
              </div>
            </div>

            <span className="viewdetails">
              <img
                onClick={navigateToRiderSales}
                className="viewimage"
                // src={viewDetailsIcon}
              />
            </span>
          </div>
          <div className="AmountContaner mt-3">
            <h3 className="total"> {customerSaleAmt || "0"}</h3>
            <div>
              <div className="profitContainer">
                {/* <img src={arrowUpIcon} />
                  <span>2%</span>{" "} */}
              </div>
              {/* <p className="last24hrs">Last 24 Hours</p> */}
            </div>
          </div>
        </div>
      </div>
      <Container fluid>
        <div style={{ paddingTop: "20px" }} className="mainCardsContainer">
          <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="sales-dashboard-card-heading">PO Details</div>
              </div>
            </div>
            <div className="AmountContaner mt-3">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Drafted</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.drafted || "0"}{" "}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Modified</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.modified || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Re-Submitted</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.resubmitted || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Pending</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.pending || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Approved</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.approved || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Recieved</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.viewVin || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Rejected</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.reject || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Hold</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.hold || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Partial Delivered</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.partialdevivere || "0"}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Cancelled</div>
                  <div className="record-values">
                    {secondRowDataVehicleVal?.cancelled || "0"}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="sales-dashboard-card-heading">TOTAL PO ITEMS</div>
              </div>
            </div>
            <div className="AmountContaner mt-3">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Total</div>
                  <div className="record-values">
                    {secondRowDataItemVal?.totalI}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Pending</div>
                  <div className="record-values">
                    {secondRowDataItemVal?.pendingI}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Approved</div>
                  <div className="record-values">
                    {secondRowDataItemVal?.approvedI}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Rejected</div>
                  <div className="record-values">
                    {secondRowDataItemVal?.rejectI}
                  </div>
                </div>

                <div
                  style={{
                    display: " flex",
                    flexDirection: "column",
                    padding: "15px",
                    background: "#F5F9FF",
                    textAlign: "center",
                  }}
                >
                  <div style={{ fontSize: "14px" }}>Done</div>
                  <div className="record-values">
                    {secondRowDataItemVal?.doneI}
                  </div>
                </div>

              </div>
            </div>
          </div> */}

          {/* <div className="maintotalleadscontainer">
            <div className="maintotalsContainers">
              <div className="totalrevenuetitle">
                <div className="sales-dashboard-card-heading" > Total Accessories</div>
              </div>
            </div>
            <div className="AmountContaner mt-3">
            <div style={{display:"flex", flexDirection:"row", justifyContent:"space-around", alignItems:"center", width:"100%"}}>
              <div style={{display:" flex", flexDirection:"column", padding:"15px",background:"#F5F9FF", textAlign:"center"}}>
              <div style={{fontSize:"14px"}} >
                  Ordered
                </div>
                <div className="record-values" >
                  {secondRowThirdSection?.total}
                </div>
              </div>

              <div style={{display:" flex", flexDirection:"column", padding:"15px",background:"#F5F9FF", textAlign:"center"}}>
              <div style={{fontSize:"14px"}} >
                   Accepted
                </div>
                <div className="record-values" >
                {secondRowThirdSection?.totalApproved}
                </div>
              </div>

              <div style={{display:" flex", flexDirection:"column", padding:"15px",background:"#F5F9FF", textAlign:"center"}}>
              <div style={{fontSize:"14px"}} >
                   Rejected
                </div>
                <div className="record-values">
                  {secondRowThirdSection?.totalReject}
                </div>
              </div>
        
              
              
              </div>
            </div>
          </div> */}
        </div>
        <Row>
          <Col style={{ padding: "40px" }} lg={6} className="charts-container">
            <div className="donut-chart">
              <div className="chart-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="charts-heading"
                    style={{
                      paddingLeft: "55px",
                      paddingTop: "25px",
                      fontSize: "21px",
                      fontWeight: "600",
                    }}
                  >
                    Purchase Order Overview
                  </div>
                </div>
                <div
                  style={{
                    padding: "0px 20px",
                    paddingTop: "40px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                  id="chart"
                >
                  <CanvasJSChart options={options} />
                </div>
              </div>
            </div>
          </Col>

          <Col style={{ padding: "40px" }} lg={6} className="charts-container">
            <div className="donut-chart">
              <div className="chart-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    className="charts-heading"
                    style={{
                      paddingLeft: "55px",
                      paddingTop: "25px",
                      fontSize: "21px",
                      fontWeight: "600",
                    }}
                  >
                    Customer Sales Overview
                  </div>
                </div>
                <div
                  style={{
                    padding: "0px 20px",
                    paddingTop: "40px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                  id="chart"
                >
                  <CanvasJSChart options={optionsSec} />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default SalesDashboard;
